module.exports = __webpack_public_path__ + "static/media/sponsorBayFloor2.707898fb.jpg";